import { get, post } from './common'
import { commonUtils } from '../commonUtils'
type ApiBaseResult = ApiTypes.ApiBaseResult

export interface UserActionInfo {
  userId?: string
  product?: string
  // 客户端类型
  clientType?: string
  // 视图载体
  carrier?: string
  // "所属模块"
  module?: string
  // 模块功能点
  function?: string
  // "对应位置"
  position?: string
  // 行为类型
  action?: string
  // 行为描述
  actionDesc?: string
  // 自定义字段,根据需要存放内容
  remark?: any
  // 站点
  site?: string
  // 元素内容
  element?: string
}

export namespace user {
  export function getLoginUrl(params: {
    utm?: string
    kword?: string
    bdUrl?: string // 包含bd_vid的url
  }): Promise<
    ApiBaseResult & {
      data: {
        scheme: { openlink: string }
        state: string
      }
    }
  > {
    return get('/auth/wxapp_oauth2/scheme', {
      ...params,
    })
  }

    export function getLoginQr() {
      return get<ApiTypes.DataResult<ServerData.LoginQrCodeData>>('/auth/register_qr', {})
    }


  // 确认H5登录状态
  export function confirmH5LoginStatus(state: string): Promise<
    ApiBaseResult & {
      data: {
        login: boolean
      }
    }
  > {
    return get('/auth/code_login_check', {
      state,
    })
  }

    // 确认H5登录状态
  export function confirmH5LoginStatusNew(state: string): Promise<
    ApiBaseResult & {
      data: {
        login: boolean
      }
    }
  > {
    return get('/auth/mnp_code_login_check', {
      state,
    })
  }

  // 获取用户信息/user_info
  export function getUserInfo(): Promise<
    ApiBaseResult & {
      data: ServerData.UserData
    }
  > {
    return get('/user_info')
  }

  export function postUserActionRecord(data: UserActionInfo) {
    return post('/user_behavior/burying', {}, data)
  }

  export function loginByWxGzh(
    code: string,
    scope?: 'snsapi_userinfo' | 'snsapi_base'
  ): Promise<
    ApiBaseResult & {
      data: ServerData.UserData
    }
  > {
    return get('/auth/code_login', {
      code,
      scope,
      browserType: commonUtils.isMobile() ? 'mobile' : 'pc',
    })
  }

  /****  PC 端接口 */
  export function getLoginQrCode(params: {
    utm?: string
    kword?: string
    bdUrl?: string // 包含bd_vid的url
  }): Promise<ApiBaseResult & { data: { imageUrl: string; state: string } }> {
    return get('/auth/wxapp_qrcode', {
      ...params,
    })
  }

  // 退出登录
  export function logout() {
    return get('/user/logout')
  }

  export function getJbangAiCode(): Promise<ApiBaseResult & { data: { code: string } }> {
    return get('/jbangai/code', {})
  }
}
